var React = require('react');

function BackArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5 1L1 7.5L7.5 14L8.207 13.293L2.914 8H23V7H2.914L8.207 1.707L7.5 1Z","fill":"#212355","stroke":"#212355","strokeWidth":"0.5"}));
}

BackArrowInline.defaultProps = {"width":"24","height":"15","viewBox":"0 0 24 15","fill":"none"};

module.exports = BackArrowInline;

BackArrowInline.default = BackArrowInline;
